import { render, staticRenderFns } from "./rates-dashboard.vue?vue&type=template&id=b2a23d76"
import script from "./rates-dashboard.ts?vue&type=script&lang=ts&external"
export * from "./rates-dashboard.ts?vue&type=script&lang=ts&external"
import style0 from "./rates-dashboard.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2a23d76')) {
      api.createRecord('b2a23d76', component.options)
    } else {
      api.reload('b2a23d76', component.options)
    }
    module.hot.accept("./rates-dashboard.vue?vue&type=template&id=b2a23d76", function () {
      api.rerender('b2a23d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rates-dashboard/rates-dashboard.vue"
export default component.exports